<template>
  <v-container class="py-12">
    <TitleHeader>FUNARPEN</TitleHeader>

    <div class="texto-justificado">
      <p>
        O Estado do Paraná, em conformidade com o artigo 8º da Lei Federal 10.169, datada de 29 de dezembro de 2000, que estabelece formas de compensação aos Registradores Civis
        das Pessoas Naturais pelos Atos Gratuitos por eles realizados, promulgou a Lei Estadual Nº 13.228 em 18 de julho de 2001. Posteriormente, esta lei foi modificada pela Lei
        Estadual nº 21.339, de 22 de dezembro de 2022. Tais legislações determinam a obrigatoriedade da aplicação do Selo de Fiscalização nos atos praticados pelos Tabeliães de
        Notas, de Protesto, Registradores de Imóveis, Registradores de Títulos e Documentos, Pessoas Jurídicas, Registradores Civis de Pessoas Naturais e Distribuidores vinculados
        à Lei 8935/94. Essas medidas resultaram na criação do Fundo de Apoio ao Registro Civil de Pessoas Naturais (FUNARPEN), cuja responsabilidade, conforme a lei, é custear os
        atos praticados gratuitamente pelos Registradores Civis de Pessoas Naturais e complementar a receita bruta mensal das serventias extrajudiciais de Registro Civil de Pessoas
        Naturais deficitárias.
      </p>

      <p>
        Nosso principal objetivo é custear os atos praticados gratuitamente pelo Registrador Civil de Pessoas Naturais e complementar a receita bruta mensal das serventias
        extrajudiciais de registro civil de pessoas naturais deficitárias, respeitando o teto de dez salários-mínimos do Estado do Paraná.
      </p>

      <p>
        Para viabilizar essa missão, a receita do FUNARPEN é proveniente do fornecimento do Selo de fiscalização incidente sobre os atos praticados pelos serviços notariais,
        registrais e de distribuição, sendo esta última atribuição limitada aos distribuidores vinculados à Lei Federal nº 8.935, de 18 de novembro de 1994.
      </p>

      <p>
        É crucial destacar que o FUNARPEN não apenas ressarce os Registradores Civis pelas gratuidades instituídas por lei, mas também promove a sustentabilidade financeira desses
        serviços essenciais para a comunidade.
      </p>

      <p>
        Estamos comprometidos em manter a integridade e a eficiência do sistema de registro civil, garantindo que ele continue a servir às necessidades de todos os paranaenses.
      </p>
    </div>
  </v-container>
</template>

<script setup>
definePageMeta({
  middleware: 'manutencao',
  title: 'FUNARPEN - Sobre',
})

useHead({
  title: 'Sobre',
  meta: [{ name: 'description', content: 'Sobre' }],
})
</script>

<style scoped>
.texto-justificado {
  max-width: 980px;
  margin: 0 auto;
  padding: clamp(1.25rem, 3vw, 2rem);
  border: 1px solid rgba(8, 47, 73, 0.12);
  border-left: 5px solid var(--funarpen-gold);
  border-radius: var(--funarpen-radius);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.96), rgba(250, 253, 255, 0.92)), #fff;
  box-shadow: var(--funarpen-shadow-soft);
}

.texto-justificado p {
  text-align: justify;
  line-height: 1.75;
  font-size: clamp(1rem, 1.2vw, 1.08rem);
  color: var(--funarpen-ink);
  margin-bottom: 1.5rem;
}

.texto-justificado p:last-child {
  margin-bottom: 0;
}
</style>
